import { render, staticRenderFns } from "./ActivityFour.vue?vue&type=template&id=0a385d4d&scoped=true"
import script from "./ActivityFour.vue?vue&type=script&lang=js"
export * from "./ActivityFour.vue?vue&type=script&lang=js"
import style0 from "./ActivityFour.vue?vue&type=style&index=0&id=0a385d4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a385d4d",
  null
  
)

export default component.exports